let updateFn: ((data?: any) => Promise<any>) | null = null;

export const registerSessionUpdater = (fn: typeof updateFn) => {
	updateFn = fn;
};

export const updateSession = async () => {
	if (updateFn) {
		await updateFn();
	}
};
